<p-multiselect
  [options]="availableCountries"
  [(ngModel)]="selectedCountries"
  [showToggleAll]="false"
  [filter]="true"
  optionLabel="displayName"
  placeholder="{{ 'country.multiselect.select' | transloco }}"
  display="chip"
  appendTo="body"
  (ngModelChange)="onSelectionChange()"
  [style]="{maxWidth: '100%'}"
  [attr.data-testid]="'filter-countries-dropdown'"
>
  <ng-template #item let-country>
    <div class="flex items-center">
      <img [src]="country.flagUrl" alt="{{ country.displayName }}" class="w-5 h-3 mr-2" />
      <div>{{ country.displayName }}</div>
    </div>
  </ng-template>
</p-multiselect>
